import { TagListProperty as TagListProp } from '../../peregrineFlowInterfaces';
import { Autocomplete, TextField, Box, Typography, Tooltip, Chip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useState, useEffect } from 'react';

function TagListProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as TagListProp;
    const [tags, setTags] = useState<string[]>(Array.isArray(p.value) ? p.value : []);
    const [changed, setChanged] = useState<boolean>(false);

    const sendOnChanged = useCallback(() => {
        if (!changed)
            return

        p.value = tags;
        onChange?.(p)
        setChanged(false);
    }, [onChange, p, setChanged, changed, tags]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (changed) {
                sendOnChanged();
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [tags, changed, sendOnChanged]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={Array.isArray(tags) ? tags : []}
                onChange={(event, newValue) => {
                    setTags(newValue);
                    setChanged(true);
                }}
                renderTags={(value: readonly string[], getTagProps) => {
                    if (!Array.isArray(value)) return null;
                    return value.map((option: string, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                            <Chip key={key} variant="outlined" label={option} {...tagProps} />
                        );
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Add values"
                    />
                )}
            />
        </Box>
    )
}

export default TagListProperty;
